import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function OrderSampleFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.orderSample.filter);

  const pageMessages = messages[lang].orderSampleListFilters;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_ORDER_SAMPLE_FILTER',
      payload: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
        dispatch({
            type: 'GET_ORDER_SAMPLES',
            page: 1,
            filter: filters,
            cleanTable: true
        })
    }
  }

  const statusFilter = [
    { id: "", message: messages[lang].all },
    { id: "1", message: "Em Aprovação" },
    { id: "2", message: "Aprovado" },
    { id: "3", message: "Reprovado" },
  ];

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.descricao}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.descricao}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, descricao: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.pedidoAmostra}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.pedidoAmostra}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, pedidoAmostra: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.pedidoOriginal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.pedidoOriginal}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, pedido: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.fornecedor}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.fornecedor}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, nomeFornecedor: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.status}</Form.Label>
                <Form.Control
                    as="select"
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.status}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, status: event.target.value },
                    )}
                >
                {
                  statusFilter.map(value => (
                    <option key={value.id} value={value.id}>{value.message}</option>
                  ))
                }
                </Form.Control>
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dataModificacao}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dataModificacao}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dataModificacao: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dataCadastro}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dataCadastro}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dataCadastro: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
    </Form>
  );
}
